<template>
<v-lazy :options="{ threshold: 0.5 }" transition="fade" :min-height="550">
    <div>
        <v-carousel height="auto" cycle show-arrows-on-hover hide-delimiter-background>
            <v-carousel-item v-for="(slide, i) in slides" :key="i" eager>
                <v-row class="fill-height" align="center" justify="center">
                    <v-img :src="slide.slide_image" class="tcdc-floor-image" aspect-ratio="1">
                        <template v-slot:placeholder>
                            <v-sheet class="fill-height" color="#EFEFEF"></v-sheet>
                        </template>
                    </v-img>
                </v-row>
                <!-- </v-sheet> -->
            </v-carousel-item>
        </v-carousel>
        <p class="text-tcdc-green sub-header2 bold mt-4">{{ title }}</p>
        <div class="vhtml mb-5" v-html="content"></div>
        <div v-if="title.indexOf('Function Room') > -1">
            <!-- <GreenButton v-if="enableButton" label="UNAVAILABLE" style="cursor: none;"></GreenButton> -->
            <v-btn v-if="enableButton" min-width="120" rounded height="30px" class="active-color" :disabled="true">
                <span class="bold text-uppercase px-5" style="color: #fff;">UNAVAILABLE</span>
            </v-btn>
        </div>
        <div v-else>
            <GreenButton v-if="enableButton" label="Book Now" @onPress="onBooking"></GreenButton>
        </div>
    </div>
</v-lazy>
</template>

<script>
import GreenButton from "../buttons/GreenButton";
export default {
    components: {
        GreenButton
    },
    props: {
        title: {
            type: String,
            default: ""
        },
        content: {
            type: String,
            default: ""
        },
        slides: {
            type: Array,
            default: null
        },
        enableButton: {
            type: Boolean,
            default: false
        }
    },
    methods: {
        onBooking() {
            this.$emit('onBooking');
        }
    },
    data: () => ({

    })
};
</script>

<style>
.tcdc-floor-image {
    width: 100%;
    object-fit: contain;
}
</style>
